import { toBoolean } from '@bechtel/ht-clients-common';
export const GATEWAY_SERVICE_URL = process.env.GATEWAY_SERVICE_URL || '';
export const API_WS = process.env.API_WS || '';
export const DEBUG = process.env.DEBUG || '';
export const ENABLE_EMULATION = process.env.ENABLE_EMULATION || '';

export const IAM_AAD_B2C_DOMAIN = process.env.IAM_AAD_B2C_DOMAIN || '';
export const IAM_AAD_B2C_AUTHORITY = process.env.IAM_AAD_B2C_AUTHORITY || '';
export const AZ_AAD_B2C_TENANT_NAME = process.env.AZ_AAD_B2C_TENANT_NAME || '';
export const AZ_AAD_B2C_WEB_CLIENT_ID = process.env.AZ_AAD_B2C_WEB_CLIENT_ID || '';
export const IAM_AAD_B2C_POLICY_NAME = process.env.IAM_AAD_B2C_POLICY_NAME || '';
export const IAM_AAD_B2C_REDIRECT_URI = process.env.IAM_AAD_B2C_REDIRECT_URI || '';
export const AZ_AAD_B2C_API_CLIENT_ID = process.env.AZ_AAD_B2C_API_CLIENT_ID || '';
export const IAM_AAD_B2C_API_SCOPE = process.env.IAM_AAD_B2C_API_SCOPE || '';
export const IAM_AAD_B2C_LOGGING_LEVEL = process.env.IAM_AAD_B2C_LOGGING_LEVEL || 'info';
export const IAM_AAD_B2C_LOGGING_NO_PII = process.env.IAM_AAD_B2C_LOGGING_NO_PII || false;

export const MAP_API_KEY = process.env.MAP_API_KEY || '';

export const envConfig = {
  gatewayServiceUrl: `${GATEWAY_SERVICE_URL}/graphql`,
  authTokenUrl: `${GATEWAY_SERVICE_URL}/auth-token`,
  apiWs: API_WS,
  debug: DEBUG,
  enableEmulation: toBoolean(ENABLE_EMULATION || 0),
  //Authentication Keys
  //IAM B2C Authentication
  tenantName: AZ_AAD_B2C_TENANT_NAME,
  clientID: AZ_AAD_B2C_WEB_CLIENT_ID,
  apiClientID: AZ_AAD_B2C_API_CLIENT_ID,
  policyName: IAM_AAD_B2C_POLICY_NAME,
  redirectURI: IAM_AAD_B2C_REDIRECT_URI,
  authority: IAM_AAD_B2C_AUTHORITY,
  b2cDomain: IAM_AAD_B2C_DOMAIN,
  apiScope: IAM_AAD_B2C_API_SCOPE,
  loggingLevel: IAM_AAD_B2C_LOGGING_LEVEL,
  loggingNoPII: IAM_AAD_B2C_LOGGING_NO_PII,
  mapApiKey: MAP_API_KEY,
};
